import { issuerConfigService } from "../services/issuerConfig.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { issuerConfigConstants, nameSpace } from "../constants/issuerConfig.constants";
import { createRequestBody } from "../factories/issuerConfig.factory";
import { reset } from "redux-form";

export const getAllIssuerConfigs = (issuerCode, pageState) => {
    return async (dispatch) => {
        const issuer = issuerCode && issuerCode.issuerCode ? issuerCode.issuerCode : issuerCode;
        dispatch(request({ issuerCode: issuer, ...pageState }));
        try {
            const response = await issuerConfigService.getAllIssuerConfigs({
                issuerCode: issuer,
                ...pageState,
            });
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get issuer card configurations", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return { type: issuerConfigConstants[`GET_${nameSpace}_REQUEST`], request };
    }
    function success(response) {
        return {
            type: issuerConfigConstants[`GET_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: issuerConfigConstants[`GET_${nameSpace}_FAILURE`], error };
    }
};

export const viewIssuerConfig = (id, issuer) => {
    return async (dispatch) => {
        dispatch(request({ id, issuer }));
        try {
            const response = await issuerConfigService.viewIssuerConfig(id, issuer);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get selected configuration", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: issuerConfigConstants[`VIEW_${nameSpace}_REQUEST`],
            request,
        };
    }
    function success(response) {
        return {
            type: issuerConfigConstants[`VIEW_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: issuerConfigConstants[`VIEW_${nameSpace}_FAILURE`], error };
    }
};

export const deleteIssuerConfig = (id) => {
    return async (dispatch) => {
        dispatch(request(id));
        try {
            const response = await issuerConfigService.deleteIssuerConfig(id);
            response && dispatch(success(response));
            dispatch(showAlert("success", "Deleted selected configuration", response && response.responseMessage));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to delete selected configuration", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: issuerConfigConstants[`DELETE_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: issuerConfigConstants[`DELETE_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: issuerConfigConstants[`DELETE_${nameSpace}_FAILURE`],
            error,
        };
    }
};
export const createIssuerConfig = (values, id, issuerCode, history) => {
    let reqIssuerCode;
    if (id) {
        reqIssuerCode = issuerCode && issuerCode.issuerCode ? issuerCode.issuerCode : "";
    } else {
        reqIssuerCode = values.scpIssuers ? values.scpIssuers.issuerCode : issuerCode ? issuerCode.issuerCode : "";
    }

    const requestBody = createRequestBody(values, reqIssuerCode, id);
    return async (dispatch) => {
        dispatch(request(requestBody));
        try {
            const response = await issuerConfigService.createIssuerConfig(requestBody, id);
            dispatch(success(response));
            dispatch(reset("issuerConfiguration_form"));
            dispatch(showAlert("success", id ? "Issuer card configuration updated successfully" : "Issuer card configuration saved successfully", response && response.responseMessage));
            dispatch(getAllIssuerConfigs(reqIssuerCode, { page: 1, pageSize: 10 }));
            dispatch(resetPost());
            if (id) {
                // dispatch(viewIssuerConfig(id, reqIssuerCode));
                history.push("/issuers/config");
            } else {
                dispatch(resetView());
            }
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", id ? "Failed to update issuer card configuration" : "Failed to save issuer card configuration", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: issuerConfigConstants[`POST_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: issuerConfigConstants[`POST_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return { type: issuerConfigConstants[`POST_${nameSpace}_FAILURE`], error };
    }
    function resetPost() {
        return { type: issuerConfigConstants[`POST_${nameSpace}_RESET`] };
    }
    function resetView() {
        return { type: issuerConfigConstants[`VIEW_${nameSpace}_RESET`] };
    }
};

export const resetPost = () => {
    return { type: issuerConfigConstants[`POST_${nameSpace}_RESET`] };
};

export const resetConfigs = () => {
    return { type: issuerConfigConstants[`GET_${nameSpace}_RESET`] };
};
